<template>
  <b-carousel
    controls
    indicators
  >
    <b-carousel-slide
      v-for="(media, i) in images"
      :key="media.id"
      style="background-color:#111;"
    >
      <template v-slot:img>
        <img
          class="d-block"
          :style="imgStyle"
          :src="media.url_full"
          :alt="''"
        >
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<script>
import { filter } from 'lodash'

export default {
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    cropped: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listing: this.value,
    }
  },
  computed: {
    images() {
      return filter(this.listing.media, (media) => {
        return media.type === 'jpeg'
      })
    },
    imgStyle () {
      return this.cropped ? 'height: 60vh; width:auto; margin:-3.8% auto' : 'height: 60vh; width:auto; margin: 0 auto;"'
    }
  }
}
</script>